import { render, staticRenderFns } from "./ProdutosSlider.vue?vue&type=template&id=1a52ebdf"
import script from "./ProdutosSlider.vue?vue&type=script&lang=js"
export * from "./ProdutosSlider.vue?vue&type=script&lang=js"
import style0 from "./ProdutosSlider.vue?vue&type=style&index=0&id=1a52ebdf&prod&lang=scss"
import style1 from "./ProdutosSlider.vue?vue&type=style&index=1&id=1a52ebdf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports